export const hasEmptyContent = (response) => response.headers['content-length']
  && Number(response.headers['content-length']) <= 0;

export const getKeyWithPrimitives = (...args) => args.reduce((acc, arg) => (
    typeof arg === 'object' || Array.isArray(arg) ? acc : [...acc, arg]
), []).join('|');
